"use client";

import { useEffect } from "react";
import Header from "@/components/headerV2";
import Hero from "@/components/herov2";
import Experiences from "@/components/experiences";
import Tickets from "@/components/ticketsV2";
import Games from "@/components/gamesV2";
import Countdown from "@/components/countdown";
import Partner from "@/components/partner";
import Sponsors from "@/components/sponsors";
import FAQ from "@/components/faq";
import Footer from "@/components/footer";
import BottomMenu from "@/components/bottomMenu";

import { FilasPageContent } from "@/components/queue/FilasPageContent";

export default function FilasPage() {
  return (
    <div className="site-shell pb-[calc(env(safe-area-inset-bottom)+104px)]">
      <Header />
      <div style={{ height: 103 }} />
      <FilasPageContent />
      <BottomMenu />
    </div>
  );
}
